function Work() {
    return (
        <div className="my__work">
            "hi"
        </div>
    )
}

export default Work;